import IncidentSection1 from './IncidentSection1';

export default IncidentSection1;
